/**
 * Shared date formatting. Hoisted so list pages don't each redefine an
 * identical `fmtDate` (was duplicated in approvals + CTC-revisions).
 */

/** Format an ISO / `YYYY-MM-DD` string as "01 Jan 2026" (en-IN). Returns '—'
 *  for empty input and the raw string if it can't be parsed. */
export function fmtDate(s: string | null | undefined): string {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** Format an ISO timestamp as "30 Sep 2026, 08:28 am" (en-IN), in the
 *  viewer's time zone. Same empty / unparseable handling as fmtDate. */
export function fmtDateTime(s: string | null | undefined): string {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
